import { c as _c } from "react/compiler-runtime";
import { FullWidthBanner } from '@systemeio/components';
import { PAGE_TEMPLATES_API } from 'modules/funnels/funnel/api/page-templates-api';
import PageTemplatePagination, { PageTemplateLimitType } from 'modules/funnels/funnel/components/page-template-selector/page-template-pagination';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { usePageTemplates } from 'modules/funnels/funnel/hooks/use-page-templates';
import { FunnelPageTemplateId } from 'modules/funnels/funnel/types/funnel-page-template-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getPageTypeFromFunnelStepType } from 'modules/funnels/funnel/utils/get-page-type-from-funnel-step-type';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import { useEffect, useState } from 'react';
import { TemplateCard } from 'shared/components/template-card';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { useSelectPageTemplate } from '../../hooks/use-select-page-template';
interface PageTemplateSelectorProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function PageTemplateSelector(t0) {
  const $ = _c(36);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const [limit, setLimit] = useState(9);
  const {
    pagination,
    setPagination
  } = usePagination(true);
  const {
    selectPageTemplate,
    isFetching
  } = useSelectPageTemplate();
  let t1;
  if ($[0] !== limit) {
    t1 = {
      limit,
      setLimit
    };
    $[0] = limit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const limiter = t1;
  let t2;
  if ($[2] !== pagination || $[3] !== setPagination) {
    t2 = {
      pagination,
      setPagination
    };
    $[2] = pagination;
    $[3] = setPagination;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const paginator = t2;
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  let t3;
  if ($[5] !== funnelStep.type) {
    t3 = getPageTypeFromFunnelStepType(funnelStep.type);
    $[5] = funnelStep.type;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== limit || $[8] !== pagination || $[9] !== t3) {
    t4 = {
      type: t3,
      limit,
      pagination
    };
    $[7] = limit;
    $[8] = pagination;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    pageTemplates
  } = usePageTemplates(t4);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      api: PAGE_TEMPLATES_API
    };
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const updateStepTemplatesData = useUpdateData(t5);
  const [selectedPageTemplate, setSelectedPageTemplate] = useState();
  let t6;
  if ($[12] !== funnelStep.id || $[13] !== mutateFunnelStepsList || $[14] !== selectPageTemplate) {
    t6 = async pageTemplateId => {
      ;
      try {
        setSelectedPageTemplate(pageTemplateId);
        const response = await selectPageTemplate(funnelStep.id, pageTemplateId);
        await mutateFunnelStepsList(data => {
          if (data) {
            return data.map(dataFunnelStep => {
              if (dataFunnelStep.id === funnelStep.id) {
                return response;
              }
              return dataFunnelStep;
            });
          }
        }, false);
        setSelectedPageTemplate(undefined);
      } catch (t7) {
        setSelectedPageTemplate(undefined);
      }
    };
    $[12] = funnelStep.id;
    $[13] = mutateFunnelStepsList;
    $[14] = selectPageTemplate;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onSelect = t6;
  let t7;
  if ($[16] !== pageTemplates || $[17] !== updateStepTemplatesData) {
    t7 = () => {
      const revalidateStepTemplates = async () => await updateStepTemplatesData(false, pageTemplates);
      if (pageTemplates) {
        revalidateStepTemplates();
      }
    };
    $[16] = pageTemplates;
    $[17] = updateStepTemplatesData;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = user?.dashboardLocale;
  let t9;
  if ($[19] !== t8) {
    t9 = [t8];
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  useEffect(t7, t9);
  const t10 = !!pageTemplates;
  let t11;
  if ($[21] !== t) {
    t11 = t("dashboard.funnel.steps.template.need_to_select");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = <FullWidthBanner variant="warning" className="desktop:hidden w-screen self-center">{t11}</FullWidthBanner>;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== isFetching || $[26] !== limiter || $[27] !== onSelect || $[28] !== pageTemplates || $[29] !== paginator || $[30] !== selectedPageTemplate) {
    t13 = !pageTemplates ? <TabContentLoader /> : <div className="flex flex-col gap-5"><div className="tablet:grid-cols-2 grid w-full grid-cols-1 justify-between gap-3">{pageTemplates.items?.map(template => <TemplateCard key={template.id} onSelect={() => onSelect(template.id)} isActive={selectedPageTemplate === template.id} isFetching={isFetching} className="aspect-video h-full w-full" preview={{
          href: `/dashboard/page/template/${template.id}/show`,
          dataTestId: `preview-template-${template.id}`
        }} dataTestId={`select-template-${template.id}`}><img alt={template.previewImage.filename} src={template.previewImage.path} data-test-element={template.name} className="w-[-webkit-fill-available]" /></TemplateCard>)}</div><PageTemplatePagination data={pageTemplates} limiter={limiter} paginator={paginator} /></div>;
    $[25] = isFetching;
    $[26] = limiter;
    $[27] = onSelect;
    $[28] = pageTemplates;
    $[29] = paginator;
    $[30] = selectedPageTemplate;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t13) {
    t14 = <div className="flex w-full flex-col gap-5" data-test-table-is-loaded={t10}>{t12}{t13}</div>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
}
export default PageTemplateSelector;